// Largest number of detail rows that is exported client-side (Kendo Excel / CSV on the browser's main
// thread). Above this the browser can hang ("Page Unresponsive"), so the export is queued to the
// Report Queue for background processing instead.
export const MAX_DIRECT_EXPORT_ROWS = 25000;

// Counts the detail rows in a grouped GetDetails result: [{ summary, details: [...] }, ...].
export function CountDirectExportDetailRows(groupedData) {
  if (!Array.isArray(groupedData)) return 0;

  return groupedData.reduce(
    (total, item) =>
      total + (item && Array.isArray(item.details) ? item.details.length : 0),
    0
  );
}

export function ExceedsDirectExportRowLimit(
  groupedData,
  maxRows = MAX_DIRECT_EXPORT_ROWS
) {
  return CountDirectExportDetailRows(groupedData) > maxRows;
}
